import store from "../store-root";
import api from "../../service/api";
import queryString from "querystring";
const moduleName = "proofing";

store.registerModule(moduleName, {
  namespaced: true,
  state: {
    proofingList: {
      list: [],
      total: 0,
    },
  },
  actions: {
    //周期批次
    async getPondUnclearedBatchNo(a, pondId) {
      let result = await api.get(
        `/api/FishBatch/GetPondUnclearedBatchNo/${pondId}`
      );
      return result.data;
    },
    //查询-----获取所有数据
    async getProofingData({ commit }, payload) {
      let result = await api.get(
        `/api/FishSample?${queryString.stringify(payload)}`
      );
      if (result.status === 200) {
        commit("setProofingList", result.data);
      }
      return result;
    },
    //添加
    async addProofing(a, payload) {
      let result = await api.post("/api/FishSample", payload);
      return result.data;
    },
    //删除数据
    async delProofing(a, payload) {
      let result = await api.delete(`/api/FishSample/` + payload);
      return result;
    },
    //删除子数据
    async delProofingDetail(a, payload) {
      let result = await api.delete(`/api/FishSample/detail/` + payload);
      return result;
    },
    //编辑---获取单行数据
    async getEditProofing(a, payload) {
      let result = await api.get(`/api/FishSample/` + payload);
      return result.data;
    },
    //修改
    async updateProofing(a, payload) {
      let result = await api.put(`/api/FishSample/${payload.id}`, payload.data);
      return result.data;
    },
  },
  mutations: {
    setProofingList(state, payload) {
      state.proofingList = payload;
    },
  },
  getters: {},
});

export default moduleName;
